import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="paypal-registration"
export default class extends Controller {
  static targets = ["team", "dayCheckbox"]

  connect() {
    this.teamTargets.forEach((team) => {
      const checkbox = this.checkboxFor(team)

      if (checkbox?.checked) {
        this.showTeam(team)
      } else {
        this.collapseTeam(team)
      }
    })
  }

  handleDayChange(event) {
    const checkbox = event.target
    const team = this.element.querySelector(`#${checkbox.value.toLowerCase()}`)

    if (!team) return

    if (checkbox.checked) {
      this.showTeam(team)
    } else {
      this.hideTeam(team)
    }
  }

  showTeam(team) {
    team.style.display = "block"
    this.setSignupFieldsRequired(team, true)
  }

  hideTeam(team) {
    this.collapseTeam(team)
    this.signupInputs(team).forEach((input) => {
      input.value = ""
    })
  }

  collapseTeam(team) {
    team.style.display = "none"
    this.setSignupFieldsRequired(team, false)
  }

  checkboxFor(team) {
    return this.dayCheckboxTargets.find((checkbox) => (
      checkbox.value.toLowerCase() === team.id
    ))
  }

  setSignupFieldsRequired(team, required) {
    this.signupInputs(team).forEach((input) => {
      input.required = required
    })
  }

  signupInputs(team) {
    return team.querySelectorAll("input.team-field, input.captain-field")
  }
}
